var styles = {"mBreakpointMd":"(min-width: 960px)","logo":"styles_logo__15AE8","logo-mark":"styles_logo-mark__3mMPU","logoMark":"styles_logo-mark__3mMPU"};

export default styles;
//# sourceMappingURL=styles.css.js.map
